import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { ComplianceInvestigationBox } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationBox";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import {
  loadNonComplianceAsync,
  selectNonCompliance,
} from "../../../redux/slices/nonCompliance";
import NonComplianceHeader from "./NonComplianceHeader";
import NonComplianceDetails from "./NonComplianceDetails";
import Page500 from "../../../pages/auth/Page500";

const NonCompliance = () => {
  const [loading, setLoading] = useState(false);
  const [loadingNonComplianceId, setLoadingNonComplianceId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const nonComplianceSelector = useAppSelector(selectNonCompliance);

  const dispatch = useAppDispatch();

  let { profileNo, nonComplianceId } = useParams();
  if (!profileNo || !nonComplianceId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingNonComplianceId !== nonComplianceId) {
    setLoadingNonComplianceId(nonComplianceId);
    dispatch(loadNonComplianceAsync(nonComplianceId));
    return <Loading />;
  }

  const nonComplianceDetails = nonComplianceSelector.nonCompliance;

  if (!nonComplianceDetails) {
    return <Loading />;
  }

  if (!nonComplianceDetails.response.ok) {
    if (nonComplianceDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <NonComplianceHeader
            licenceProfile={licenceProfile}
            nonComplianceDetails={nonComplianceDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <NonComplianceDetails nonComplianceDetails={nonComplianceDetails} />
        </Col>
      </Row>
      {nonComplianceDetails.complianceInvestigationDetails && (
        <Row>
          <Col className="col-12 col-sm-12 col-md-12">
            <ComplianceInvestigationBox
              complianceInvestigationDetails={
                nonComplianceDetails.complianceInvestigationDetails
              }
              licenceProfile={licenceProfile}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            nonComplianceDetails={nonComplianceDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        nonComplianceDetails={nonComplianceDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default NonCompliance;
